import React, { ReactElement, useEffect } from 'react';
import { useTypedSelector } from '../common/custom-hooks';
import { userSelectors } from '../ducks/user/selectors';
import { uiSelectors } from '../ducks/ui/selectors';
import { useTKNavigate } from '../common/navigation';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { uiActions } from '../ducks/ui/actions';
import { Login } from '../components/login';
import { PageError } from '../components/page-error';
import { PageLoading } from '../components/page-loading';
import { useIsQueryClientReady } from '../utils/query-client-ready';
export const Private = ({
  element
}: {
  element: ReactElement;
}) => {
  const isQueryClientReady = useIsQueryClientReady();
  const authUser = useTypedSelector(userSelectors.getAuthUser);
  const initializationStatus = useTypedSelector(uiSelectors.getInitializationStatus);
  const navigate = useTKNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const errorAction = () => dispatch(uiActions.initialize());
  const pathAndParams = window.location.href.split('?');
  const params = pathAndParams.length > 1 ? pathAndParams.pop() : '';
  const paramsWithoutSyncing = params?.split('&').filter(param => !param.includes('syncing')).join('&');
  const hasReloaded = params?.includes('syncing');
  useEffect(() => {
    if (hasReloaded) {
      const pathWithoutParams = location.pathname.split('?')[0];
      const pathWithoutSyncingParam = `${pathWithoutParams}?${paramsWithoutSyncing ?? ''}`;
      navigate(pathWithoutSyncingParam, {
        replace: true
      });
    }
  }, [hasReloaded, paramsWithoutSyncing, location.pathname, navigate]);
  if (!authUser?.username) {
    return <Login />;
  }
  if (initializationStatus.error) {
    return <PageError errorText="Kunne ikke laste inn Tilsynskvittering." errorAction={errorAction} errorActionText="Prøv å laste innhold på nytt" />;
  }
  if (!initializationStatus.loaded) {
    return <PageLoading loadingText="Laster tilsynskvittering..." />;
  }
  if (!isQueryClientReady) {
    return <PageLoading loadingText="Venter på tilsynskvittering..." />;
  }
  return element;
};